import * as types from './types'
import * as requests from '@cbgms/api/modules/recently-opened/requests'
import { APIResponse, GETRecentlyOpenedEntitiesResponse, RecentlyOpenedEntity } from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { RecentlyOpenedEntityType } from '@cbgms/api/modules/enums'

export const getRecentlyOpened = (amount: number, type: RecentlyOpenedEntityType) =>
  AsyncAction<GETRecentlyOpenedEntitiesResponse>({
    type: [types.GET_RECENTLY_OPENED, types.GET_RECENTLY_OPENED_SUCCESS, types.GET_RECENTLY_OPENED_FAILED],
    payload: {
      api: 'gms',
      request: requests.getRecentlyOpenedRequest(amount, type)
    }
  })

export const putRecentlyOpenedEntity = (entityType: RecentlyOpenedEntityType, entityUUID: string) =>
  AsyncAction({
    type: [types.PUT_RECENTLY_OPENED, types.PUT_RECENTLY_OPENED_SUCCESS, types.PUT_RECENTLY_OPENED_FAILED],
    payload: {
      api: 'gms',
      request: requests.putRecentlyOpenedRequest(entityType, entityUUID)
    }
  })

export const getRecentlyOpenedEntities: (amount: number) => ReturnType<typeof AsyncAction<APIResponse<RecentlyOpenedEntity[]>>> = (
  amount: number
) =>
  AsyncAction<APIResponse<RecentlyOpenedEntity[]>>({
    type: [types.GET_RECENTLY_OPENED_ENTITIES, types.GET_RECENTLY_OPENED_ENTITIES_SUCCESS, types.GET_RECENTLY_OPENED_ENTITIES_FAILED],
    payload: {
      api: 'gms',
      request: requests.getRecentlyOpenedEntitiesRequest(amount)
    }
  })
